import { Onboarding } from "../onboarding";

export const onboardingRoutes = [
  {
    path: "/onboarding",
    Component: Onboarding,
    exact: true,
    isPrivate: false,
  },
  {
    path: "/onboarding/:profileId",
    Component: Onboarding,
    exact: true,
    isPrivate: false,
  },
];
